import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import styles from './Testimonial.module.scss';
import cx from 'classnames';
import { MEDIA_TYPES, ICONS_PATH, MEDIA_TYPE } from '../../lib/constants';
import { Icon, Text } from '../index';
import { Media } from '../lazyComponents';

const Testimonial = (props) => {
    const {
        mediaType,
        name,
        rating,
        testimonial,
        profileImage,
        youtubeVideoLink,
        youtubeThumbnail,
    } = props;

    let finalMediaType = mediaType;
    const isProfile = mediaType === MEDIA_TYPES.PROFILE_IMAGE;
    const hasProfileImage = profileImage && profileImage.trim().length !== 0;
    const isVideo = mediaType === MEDIA_TYPES.VIDEO;
    const hasVideoLink = youtubeVideoLink && youtubeVideoLink.trim().length !== 0;

    if ((isProfile && !hasProfileImage) || (isVideo && !hasVideoLink)) {
        finalMediaType = MEDIA_TYPES.QUOTE;
    }

    const testimonialText = (
        <div className={cx(styles['text'], 'light-theme')}>{<Text content={testimonial} />}</div>
    );

    const nameText = <div className={cx(styles.name)}>{name}</div>;
    const starUrl = ICONS_PATH + 'star.svg';
    const halfStarUrl = ICONS_PATH + 'half-star.svg';

    const starRating =
        rating !== null && rating !== undefined ? (
            <div className={cx(styles['rating-stars'])}>
                {Array(Math.floor(rating))
                    .fill(0)
                    .map((_, i) => {
                        return (
                            <Icon
                                key={`${name}-rating-${i}`}
                                url={starUrl}
                                size={'x-small'}
                                className={styles['star-icon']}
                            />
                        );
                    })}
                {rating % 1 !== 0 && (
                    <Icon url={halfStarUrl} size={'x-small'} className={styles['half-star-icon']} />
                )}
            </div>
        ) : null;

    const quoteOnly = (
        <div className={cx(styles['quote-container'])}>
            {starRating}
            <div className={cx(styles['text-container'])}>
                {testimonialText}
                {nameText}
            </div>
        </div>
    );

    const profileImageOnly = (
        <>
            <div className={cx(styles['profile-container'])}>
                <div className={cx(styles['photo-wrapper'])}>
                    <Suspense fallback={''}>
                        <Media
                            fileReference={profileImage}
                            altText={'profile photo'}
                            className={cx(styles['photo'])}
                        />
                    </Suspense>
                </div>
                <div className={styles['profile-rating-wrapper']}>
                    {nameText}
                    {starRating}
                </div>
            </div>
            {testimonialText}
        </>
    );

    const videoOnly = (
        <Suspense fallback={''}>
            <Media
                videoLink={youtubeVideoLink}
                fileReference={youtubeThumbnail}
                className={cx(styles['video-thumbnail'])}
            />
        </Suspense>
    );

    const isVideoType = finalMediaType === MEDIA_TYPES.VIDEO;
    return !isVideoType ? (
        {
            'quote-only': (
                <div className={cx(styles['testimonial-card'], styles['less-right-padding'])}>
                    {quoteOnly}
                </div>
            ),
            'profile-image': (
                <div className={cx(styles['testimonial-card'])}> {profileImageOnly}</div>
            ),
        }[finalMediaType]
    ) : (
        <div className={cx(styles['video-testimonial-wrapper'])}>
            {videoOnly}
            <div className={cx(styles['video-testimonial-card-wrapper'])}>
                <div className={cx(styles['testimonial-card'])}>{quoteOnly}</div>
            </div>
        </div>
    );
};

Testimonial.displayName = 'Testimonial';

Testimonial.propTypes = {
    mediaType: PropTypes.oneOf(MEDIA_TYPE).isRequired,
    rating: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    testimonial: PropTypes.string.isRequired,
    profileImage: PropTypes.string,
    youtubeVideoLink: PropTypes.string,
    youtubeThumbnail: PropTypes.string,
};

Testimonial.defaultProps = {
    rating: 0,
};

export default Testimonial;
